import { isTelegramWebApp } from "../../Utils/utils";

const StarComponent = (props) => {
    const starImageUrl = isTelegramWebApp() ? "/img/sgt-tgr-favorites-icon.png" : "/img/star-24-white.png";
    return (
        <div className="star-comp">
            <img src={props.imgUrl? props.imgUrl : starImageUrl} />
        </div>
    )
}

export default StarComponent;